import { fetcher } from "helpers/fetcher";

import {
  TDeleteStaffMaternityChldrenLeaveReq,
  TDeleteStaffMaternityChldrenLeaveRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteEmployeeMaternityChldrenLeave = async (
  payload: TDeleteStaffMaternityChldrenLeaveReq
) => {
  return await fetcher<
    TDeleteStaffMaternityChldrenLeaveRes,
    TDeleteStaffMaternityChldrenLeaveReq["data"]
  >(ENDPOINT.USER.DELETE_EMPLOYEE_MATERNITY_CHILDREN_LEAVE, {
    data: payload.data,
    headers: {
      [API_HEADER.USER_ID]: payload.idUser,
      [API_HEADER.VERSION]:
        ENDPOINT.USER.DELETE_EMPLOYEE_MATERNITY_CHILDREN_LEAVE.version,
    },
  });
};

export const mutationDeleteEmployeeMaternityChldrenLeave = async (
  payload: TDeleteStaffMaternityChldrenLeaveReq
) => {
  return (await deleteEmployeeMaternityChldrenLeave(payload)).data.message;
};

mutationDeleteEmployeeMaternityChldrenLeave._key = (
  payload: TDeleteStaffMaternityChldrenLeaveReq
) => [ENDPOINT.USER.DELETE_EMPLOYEE_MATERNITY_CHILDREN_LEAVE.url, payload];
